// Gestión del staff desde el panel de la empresa dueña (fase 2).
// Contrato: docs/CONTRATO-API-FASE2.md, endpoints 1 a 7. Token de empresa.
import { empresaFetch as request } from './empresaApi';

export const STAFF_ROLES = {
  scanner: {
    label: 'Escáner',
    description: 'Solo escanea y valida QRs de las actividades que le asignes.',
  },
  operator: {
    label: 'Operador',
    description: 'Escanea QRs y también crea ventas en persona de las actividades que le asignes (cobra en el lugar, ve y comparte sus tickets).',
  },
};

export const listStaff = () => request('/api/empresa/staff');

export const createStaff = (payload) =>
  request('/api/empresa/staff', { method: 'POST', body: payload });

// Solo los campos que se mandan cambian; `password` cierra todas sus sesiones.
export const updateStaff = (id, payload) =>
  request(`/api/empresa/staff/${id}`, { method: 'PATCH', body: payload });

// Reemplaza la lista completa de actividades asignadas.
export const setStaffActivities = (id, activityIds) =>
  request(`/api/empresa/staff/${id}/activities`, { method: 'PUT', body: { activityIds } });

export const revokeStaff = (id) =>
  request(`/api/empresa/staff/${id}/revoke`, { method: 'POST' });

export const reactivateStaff = (id) =>
  request(`/api/empresa/staff/${id}/reactivate`, { method: 'POST' });

// Actividades de la empresa (para asignarlas). El contrato permite asignar
// también borradores e inactivas; las eliminadas no vienen en este listado.
export const listEmpresaActivities = async () => {
  const data = await request('/api/empresa/activities');
  return data.activities || [];
};
